import { render, staticRenderFns } from "./CreatorInvitePage.vue?vue&type=template&id=224af8ad&"
import script from "./CreatorInvitePage.vue?vue&type=script&lang=js&"
export * from "./CreatorInvitePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports